import { createFileRoute } from '@tanstack/react-router'
import { PrivacyPage } from '~/components/marketing/privacy-page'
import { marketingPageHead } from '~/lib/site-meta'

const TITLE = 'Política de Privacidade | Planno'
const DESCRIPTION =
  'Como o Planno coleta, usa, armazena e protege seus dados pessoais. Bases legais sob a LGPD, cookies, direitos do titular e contato do encarregado.'

export const Route = createFileRoute('/politica-de-privacidade')({
  component: PrivacyPage,
  head: () =>
    marketingPageHead({
      description: DESCRIPTION,
      locale: 'pt-BR',
      path: '/politica-de-privacidade',
      title: TITLE,
    }),
})
